import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import './ToolActionResultDialog.css';

export default function ToolActionResultDialog({
    isOpen,
    viewLogsHandler,
    submitHandler,
    toolActionResult
}) {
    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={`wrapDialog tool-action-result-popup`}
        >
            <DialogContent>
                <div className="popup-content">
                    <div className="popup-label">
                        {I18n.get('COMPLETION')}
                    </div>

                    <ul className="popup-detail-list">
                        <li className="popup-detail-item">
                            <p className="item-label">{I18n.get('SUCCESS_COUNT')}</p>
                            <p className="item-info success">{toolActionResult?.successCount || 0}</p>
                        </li>
                        <li className="popup-detail-item">
                            <p className="item-label">{I18n.get('FAIL_COUNT')}</p>
                            <p className="item-info fail">{toolActionResult?.failCount || 0}</p>
                        </li>
                    </ul>

                    <div className="popup-btns">
                        <Button
                            className='popup-btn sub-primary'
                            onClick={viewLogsHandler}
                        >
                            {I18n.get('VIEW_LOG_DETAIL')}
                        </Button>
                        <Button
                            className='popup-btn primary'
                            onClick={submitHandler}
                        >
                            {I18n.get('SUBMIT')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
